import { render, staticRenderFns } from "./BarGridVerticalChart.vue?vue&type=template&id=22e309bb&"
import script from "./BarGridVerticalChart.vue?vue&type=script&lang=js&"
export * from "./BarGridVerticalChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports